module.exports = __webpack_public_path__ + "img/17a003-18.2cee0df4.png";